/**
 * 插入script在页面
 * @param url
 * @param callback
 */
export function loadScript(url) {
  window.loadedScript = window.loadedScript || []

  return new Promise(resolve => {
    if (window.loadedScript.includes(url)) {
      resolve({
        code: 1,
        msg: 'this script was loaded'
      })
      return
    }
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    document.getElementsByTagName('head')[0].appendChild(script)

    script.onload = function() {
      script.onload = null
      window.loadedScript.push(url)
      resolve({
        code: 1,
        msg: 'script load success!'
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/loadScript.js